// extracted by mini-css-extract-plugin
module.exports = {"classification-container":"Classification_classification-container__V6RDA"};